import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1413a822"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "JoinDialog",
  "data-test": "join-dialog"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "JoinDialog__header" }, null, -1))
const _hoisted_3 = { class: "JoinDialog__avatar" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  class: "JoinDialog__des",
  "data-test": "join-dialog-text"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "JoinDialog__decoration" }, null, -1))
const _hoisted_8 = ["onClick"]

import { useClockOn } from '@/hooks/useClockOn';
import { computed } from 'vue';
import { useStore } from '@/store';


export default /*#__PURE__*/_defineComponent({
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const store = useStore();
const { clockOnCanObtain, debounceClockOn } = useClockOn();

/**
 * 加入队伍可获得多少KK币
 */
const joinShareAssistanceTeamCanObtain = computed(
  () => store.state.rule.joinShareAssistanceTeamCanObtain
);

const avatar = computed(() => store.state.user.avatar);



function onClose () {
  emit('close');
}

function onBtn () {
  onClose();
  debounceClockOn(`完成打卡可多赚${clockOnCanObtain.value}KK币`);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "JoinDialog__container",
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "JoinDialog__img",
          src: _unref(avatar)
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, " +" + _toDisplayString(_unref(joinShareAssistanceTeamCanObtain)) + "KK币 ", 1),
      _createElementVNode("div", {
        class: "JoinDialog__btn",
        "data-test": "join-dialog-call",
        onClick: _withModifiers(onBtn, ["stop"])
      }, " 完成打卡，可多赚" + _toDisplayString(_unref(clockOnCanObtain)) + "KK币 ", 9, _hoisted_6),
      _hoisted_7
    ]),
    _createElementVNode("div", {
      class: "JoinDialog__close",
      "data-test": "close-btn",
      onClick: _withModifiers(onClose, ["stop"])
    }, null, 8, _hoisted_8)
  ]))
}
}

})